import type { Alias } from '#shared/api/schema';
import { CONSTRUCTOR_ACCOUNT_PAGES } from '../constants';

export const isConstructorPageAccount = (alias: Alias) => alias && CONSTRUCTOR_ACCOUNT_PAGES.includes(alias);
